import React, { useEffect, useState } from 'react';
import { Router } from './Router';
import { useAuthStore } from '@/store/authStore';
import { useTheme, useTelegram } from '@/hooks';
import './styles/global.css';

export const App: React.FC = () => {
  const { initialize } = useAuthStore();
  const { isReady, expand } = useTelegram();
  const [isInitialized, setIsInitialized] = useState(false);

  // Apply Telegram theme
  useTheme();

  // Initialize app
  useEffect(() => {
    // Initialize auth from storage
    initialize();

    // Expand Telegram viewport
    if (isReady) {
      expand();
    }

    // Small delay to ensure everything is loaded
    const timer = setTimeout(() => {
      setIsInitialized(true);
    }, 100);

    return () => clearTimeout(timer);
  }, [initialize, isReady, expand]);

  if (!isInitialized) {
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'var(--tg-theme-bg-color, #ffffff)',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '16px',
          }}
        >
          <div
            style={{
              width: '48px',
              height: '48px',
              border: '3px solid var(--tg-theme-button-color, #3390ec)',
              borderTopColor: 'transparent',
              borderRadius: '50%',
              animation: 'spin 0.8s linear infinite',
            }}
          />
          <span
            style={{
              fontSize: '14px',
              color: 'var(--tg-theme-hint-color, #999999)',
            }}
          >
            Loading CryptoBuzzer...
          </span>
        </div>
        <style>
          {`@keyframes spin { to { transform: rotate(360deg); } }`}
        </style>
      </div>
    );
  }

  return <Router />;
};

export default App;
